import axios from 'axios'
const { locales } = window.config

export const state = {
  StaticContents: []
}
export const getters = {
  staticContents: (state) => {
    return state.StaticContents
  },
  staticContentById: (state) => (staticContentId) => {
    return state.StaticContents.find(staticContent => staticContent.id === staticContentId)
  },
  staticContentByIdentifierAndLocale: (state) => (identifier, locale) => {
    return state.StaticContents.find(staticContent => staticContent.identifier === identifier && staticContent.locale === locale)
  },
  staticContentBySlug: (state) => (staticContentSlug) => {
    return state.StaticContents.find(staticContent => staticContent.slug === staticContentSlug)
  },
  staticContentsByIds: (state) => (staticContentIds) => {
    return state.StaticContents.filter(staticContent => staticContentIds.indexOf(staticContent.id) > -1)
  },
  staticContentMissingForIdentifierAndLocale: (state) => (identifier) => {
    const localesReturnable = []
    const localesKeys = Object.keys(locales)
    // console.log(localesKeys)
    for (let i = 0; i < localesKeys.length; i++) {
      if (state.StaticContents.filter(item => item.identifier === identifier && item.locale === localesKeys[i]).length === 0) {
        localesReturnable.push(localesKeys[i])
      }
    }
    console.log(localesReturnable)
    return localesReturnable
  }
}

export const mutations = {
  staticContents (state, staticContents) {
    state.StaticContents = staticContents
  },
  staticContentPatch (state, staticContent) {
    if (!staticContent) {
      return
    }

    const index = state.StaticContents.findIndex(item => item.id === staticContent.id)
    if (index > -1) {
      state.StaticContents.splice(index, 1, staticContent)
    } else {
      state.StaticContents.push(staticContent)
    }
  },
  staticContentDelete (state, staticContentId) {
    const index = state.StaticContents.findIndex(item => item.id === staticContentId)
    if (index > -1) {
      state.StaticContents.splice(index, 1)
    }
  }
}

export const actions = {
  async staticContentById (store, staticContentId) {
    const { data } = await axios.get('/api/static-contents/' + staticContentId)
    store.commit('staticContentPatch', data)
    return data
  },
  async staticContentBySlug (store, payload) {
    const { data } = await axios.get('/api/static-content', {
      params: {
        slug: payload.slug,
        locale: payload.locale
      }
    })
    store.commit('staticContentPatch', data)
    return data
  },
  async staticContentByIdentifierAndLocale (store, payload) {
    console.log('trying')
    const { data } = await axios.get('/api/static-content-by-identifier', {
      params: {
        identifier: payload.identifier,
        locale: payload.locale
      }
    })
    if (data) {
      store.commit('staticContentPatch', data)
    }
    return data
  },
  async staticContents (store, params = {}) {
    if (!params.page) {
      params.page = 1
    }
    const { data } = await axios.get('/api/static-contents', { params: params })

    store.commit('staticContents', data.data)
    return data
  },
  async staticContentDelete (store, staticContentId) {
    await axios.delete('/api/static-contents/' + staticContentId)
    store.commit('staticContentDelete', staticContentId)
  },
  async staticContentPatch (store, payload = {}) {
    const { data } = await axios.patch('/api/static-contents/' + payload.id, payload)
    store.commit('staticContentPatch', data)
    return data
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
